import React, { useEffect } from 'react';
import NavigationMessagePage from '../NavigationMessagePage';
import { LIFEWAY_COM_URL } from '../../constants';
import userManager from '../../utils/userManager';

const SignoutRedirectCallbackPage = () => {
  useEffect(() => {
    userManager.signoutRedirectCallback()
      .then(() => {
        window.location.href = LIFEWAY_COM_URL;
      });
  }, []);

  const signoutRedirect = () => {
    userManager.signoutRedirect();
  };

  return <NavigationMessagePage message="signing out..." retryAction={signoutRedirect} />;
};

export default SignoutRedirectCallbackPage;
